// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake"}[chunkId] + "." + {"102":"5b9b5bfc","133":"d0a4bd80"}[chunkId] + ".chunk.js";
};